import { render, staticRenderFns } from "./SideBarCmp.vue?vue&type=template&id=07d85530&"
import script from "./SideBarCmp.vue?vue&type=script&lang=js&"
export * from "./SideBarCmp.vue?vue&type=script&lang=js&"
import style1 from "./SideBarCmp.vue?vue&type=style&index=1&id=07d85530&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports